import { createModule } from '~/factories/store'
import mutations from '~/store/modules/shared/app-confirmation-modal/mutations'
import state from '~/store/modules/shared/app-confirmation-modal/state'

export default createModule({
  mutations,
  state
})
